import React from "react";
import BoxWrapper from "../ui/BoxWrapper";
import Pagination from "../ui/Pagination";
import RenderTable from "../ui/RenderTable";
import PointsHistoryTable from "./tables/PointTable";

const POINT_TYPES = [
  { label: "Tous", value: "" },
  { label: "Rservation", value: "BOOKING" },
  { label: "Course", value: "RIDE" },
];

interface Props {
  data: any;
  isLoading: boolean;
  filters: any;
  setFilters: (filters: any) => void;
  onPageChange: (page: number) => void;
  user: User;
}

export const UserPointsHistoryTab: React.FC<Props> = ({
  data,
  isLoading,
  filters,
  setFilters,
  onPageChange,
  user,
}) => {
  return (
    <div className="p-4 border bg-white rounded-4">
      <h2 className="text-xl font-bold mb-4">Historique des points</h2>

      <BoxWrapper>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <select
            className="form-select w-auto"
            value={filters.type || ""}
            onChange={(e) =>
              setFilters({
                ...filters,
                type: e.target.value,
                page: 1,
              })
            }
          >
            {POINT_TYPES.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>

          {!isLoading && data?.meta?.totalItems > 0 && (
            <div className="bg-gradient-primary p-3 text-white fw-bold rounded">
              Points: {user.points}
            </div>
          )}
        </div>

        <RenderTable
          loading={isLoading && !data?.meta?.totalItems}
          render={() => {
            if (isLoading && !data?.meta?.totalItems) return null;

            if (!data?.meta?.totalItems) {
              return (
                <p className="text-center fs-5 my-2">
                  Aucun historique trouvé.
                </p>
              );
            }

            return <PointsHistoryTable items={data.items} />;
          }}
        />
      </BoxWrapper>

      {data?.meta?.totalPages > 1 && (
        <Pagination
          currentPage={filters.page}
          onPageChange={onPageChange}
          totalCount={data?.meta?.totalPages || 0}
          pageSize={filters.limit}
          siblingCount={1}
        />
      )}
    </div>
  );
};
